import axios from 'axios'
import authHeader from './AuthHeader'

const API_URL = process.env.VUE_APP_MS_CORE


class TeamsService {


  getConfigsForSerial(serial) {
    return axios.get(`${API_URL}/configs/${serial}`, { headers: authHeader() });
  }

  updatePlanKrefeld(payload) {
    return axios.post(`${API_URL}/plan/update`, payload, {
      headers: authHeader(),
    });
  }

  findLastPlan() {
    return axios.get(`${API_URL}/plan/last`, { headers: authHeader() });
  }

  getUsersClient(customerName) {
    return axios.get(`${API_URL}/userscustomer/${customerName}`, {
      headers: authHeader(),
    });
  }

  setToDelUserClient(userClientMail) {
    return axios.get(`${API_URL}/userscustomer/del/${userClientMail}`, {
      headers: authHeader(),
    });
  }

  updateUserRoleClient(userid, roleid, newRoleLibelle) {
    return axios.get(
      `${API_URL}/userscustomer/update/role/${userid}/${roleid}/${newRoleLibelle}`,
      { headers: authHeader() }
    );
  }

  saveAlert(sralertId, payload) {
    return axios.post(`${API_URL}/teams/sralerts/${sralertId}`, payload, {
      headers: authHeader(),
    });
  }

  getSrAlert(mail) {
    return axios.get(`${API_URL}/teams/sralerts/?mail=${mail}`, {
      headers: authHeader(),
    });
  }

  getQuotationSentAlert(mail, client) {
    return axios.get(
      `${API_URL}/teams/quotations-sent-alerts/?mail=${mail}&client=${client}`,
      {
        headers: authHeader(),
      }
    );
  }

  saveQuotationAlert(sralertId, payload) {
    return axios.post(
      `${API_URL}/teams/quotation-sent-alerts/${sralertId}`,
      payload,
      {
        headers: authHeader(),
      }
    );
  }
}

export default new TeamsService()